export default __webpack_public_path__ + "static/media/file_download_black_24dp.893e8bbc.svg";